import React from 'react';

import { useSlider } from '@/hooks/useSlider';

import { ButtonsSlider } from '@/components/global/ButtonSlider';

import {
  TRecommendation,
  TVoucher,
} from '@/services/requests/Recommendation/types/template5';

import { getUuid } from '@/helpers/StringHelper/uuid';

import { CardLogged } from './CardLogged';
import { CardUnLogged } from './CardUnLogged';

export const VouchersCarrousel = ({
  id: recId,
  component,
}: {
  id: TRecommendation['id'];
  component: TVoucher;
}) => {
  const { cards } = component;

  const {
    sliderState,
    moveSliderTo,
    containerRef,
    moveSlider,
    checkScrollLimit,
  } = useSlider(
    { id: recId, cards } as unknown as TRecommendation,
    'tabName',
    true,
    '1',
    'vitrine-template5__vouchers_carrousel__card',
  );

  return (
    <div
      className="vitrine-template5__vouchers_carrousel"
      data-testid="vouchers-carrousel"
    >
      {cards.length >= 2 && (
        <ButtonsSlider
          handleClick={e => moveSlider(e)}
          sliderScroll={sliderState.scroll}
          checkScrollLimit={checkScrollLimit}
          template="5"
        />
      )}

      <div
        className="vitrine-template5__vouchers_carrousel__cards"
        ref={containerRef}
      >
        {cards.map((card, index) => {
          const { type } = card;
          return type === '["reusable_voucher"]' || type === '["voucher"]' ? (
            <CardLogged
              card={card}
              key={getUuid()}
              recommendationId={recId}
              index={index}
            />
          ) : (
            <CardUnLogged card={card} key={getUuid()} index={index} />
          );
        })}
      </div>

      {cards.length > 1 && (
        <div className="vitrine-template5__slider-dots">
          {cards.map((card, i) => {
            return (
              <span
                role="button"
                className={`vitrine-template5__slider-dot${
                  i + 1 === sliderState.current ? ' current' : ''
                }`}
                key={getUuid()}
                onClick={() => moveSliderTo(i)}
                aria-hidden="true"
                data-testid={`dot-${i + 1}`}
              >
                {i + 1}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};
